import {
    createSelector
} from 'reselect';

export const allOrderPlanningSelector = createSelector(state => state.orderPlanning && state.orderPlanning.allOrderPlanning, allOrderPlanningSelector => allOrderPlanningSelector )
export const allShippedFTLSelector = createSelector(state => state.orderPlanning && state.orderPlanning.allShippedFTL, allShippedFTLSelector => allShippedFTLSelector )
